import { FOCUSABLES_SELECTOR, isElementFocusable } from './is-focusable';
import getNewIndex from './get-new-index';

export default function setupFocusTrap(
	container,
	focusables = FOCUSABLES_SELECTOR,
	options = {},
	callback = null,
) {
	let enabled;

	if ( typeof focusables === 'boolean' ) {
		options = focusables;
		focusables = FOCUSABLES_SELECTOR;
	}
	if ( typeof focusables === 'function' ) {
		callback = focusables;
		focusables = FOCUSABLES_SELECTOR;
	}
	if ( typeof options === 'function' ) {
		callback = options;
		options = false;
	}

	if ( focusables instanceof NodeList ) {
		focusables = [ ...focusables ];
	}

	function handleFocus( target, event, possibleTargets ) {
		if ( ! enabled ) {
			return;
		}

		// Allow trap to be only active sometimes
		if ( typeof options.ignoreCondition === 'function' &&
			options.ignoreCondition( event, target, possibleTargets ) ) {
			return;
		}

		const index = possibleTargets.indexOf( target );

		let newIndex;
		if ( options.arrowKeys ) {
			switch ( event.key ) {
				case 'ArrowUp':
					if ( ! options.leftRightOnly ) {
						newIndex = getNewIndex( index, possibleTargets.length, -1 );
					}
					break;

				case 'ArrowLeft':
					if ( ! options.upDownOnly ) {
						newIndex = getNewIndex( index, possibleTargets.length, -1 );
					}
					break;

				case 'ArrowDown':
					if ( ! options.leftRightOnly ) {
						newIndex = getNewIndex( index, possibleTargets.length, 1 );
					}
					break;

				case 'ArrowRight':
					if ( ! options.upDownOnly ) {
						newIndex = getNewIndex( index, possibleTargets.length, 1 );
					}
					break;

				case 'Home':
					newIndex = 0;
					break;

				case 'End':
					newIndex = possibleTargets.length - 1;
					break;
			}
		} else if ( event.key === 'Tab' ) {
			newIndex = getNewIndex( index, possibleTargets.length, ! event.shiftKey );
		}

		if ( typeof newIndex !== 'undefined' ) {
			event.preventDefault();
			possibleTargets[ newIndex ].focus();
			if ( typeof callback === 'function' ) {
				callback( possibleTargets[ newIndex ] );
			}
		}
	}

	if ( typeof focusables === 'string' ) {
		container.addEventListener( 'keydown', event => {
			// Check that target is a focusable element within the container
			if ( event.target !== container && event.target.matches( focusables ) ) {
				let elements = [ ...container.querySelectorAll( focusables ) ];
				if ( ! options.assumeFocusable ) {
					elements = elements.filter( isElementFocusable );
				}

				handleFocus( event.target, event, elements );
			}
		} );
	} else {
		focusables.forEach( element => {
			element.addEventListener( 'keydown', event => {
				let elements = focusables;
				if ( ! options.assumeFocusable ) {
					elements = elements.filter( isElementFocusable );
				}

				handleFocus( event.target, event, elements );
			} );
		} );
	}

	function toggleTrap( toggle ) {
		if ( typeof toggle === 'undefined' ) {
			toggle = ! enabled;
		}

		enabled = toggle;
	}

	return toggleTrap;
}
